var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongLoadingSpinner = function SvgLongLoadingSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#827127",
    d: "M109 62.5c0 25.681-20.819 46.5-46.5 46.5S16 88.181 16 62.5 36.819 16 62.5 16 109 36.819 109 62.5m-88.35 0c0 23.113 18.737 41.85 41.85 41.85s41.85-18.737 41.85-41.85S85.613 20.65 62.5 20.65 20.65 39.387 20.65 62.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9FA",
    d: "M18.325 62.5c-1.284 0-2.331 1.042-2.267 2.324a46.5 46.5 0 1 0 48.766-48.766c-1.282-.064-2.324.983-2.324 2.267s1.042 2.318 2.324 2.39a41.85 41.85 0 1 1-44.11 44.109c-.07-1.282-1.105-2.324-2.389-2.324"
  })));
};
export default SvgLongLoadingSpinner;